<div mat-dialog-title>
  {{ modalData.title }}
  <div style="float: right; margin-top: -5px;">

    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content *ngIf="modalData.isEdit" class="mat-typography">
  <mat-spinner *ngIf="isLoading" class="spinner-center" diameter="40" style="z-index: 1000;"></mat-spinner>
  <div class="row d-flex justify-content-center">
    <div class="col-12 p-3">
      <p style="font-size: medium;" class="text-center lifedi-color">หลักฐานการโอนไม่ถูกต้อง เพราะ...</p>
      <div class="row ">
        <div class="col d-flex justify-content-center">
          <form [formGroup]="filterForm">
            <mat-radio-group formControlName="selectType" (change)="select(filterForm.value.selectType)">
              <mat-radio-button value="ไม่มียอดเงินเข้าตามสลิป">ไม่มียอดเงินเข้าตามสลิป</mat-radio-button><br>

              <mat-radio-button value="จำนวนเงินไม่ถูกต้อง">จำนวนเงินไม่ถูกต้อง</mat-radio-button><br>
              <div *ngIf="filterForm.value.selectType === 'จำนวนเงินไม่ถูกต้อง'" class="row">
                <label class="text-right form-label col-4 mt-2">ชำระเพิ่ม</label>
                <input type="number" formControlName="price" class="form-control col-4">
                <label class="form-label col-4 mt-2">บาท</label> <br>
              </div>

              <mat-radio-button value="อื่นๆ">อื่นๆ</mat-radio-button><br>
            </mat-radio-group>
            <textarea *ngIf="filterForm.value.selectType === 'อื่นๆ'" class="form-control" id="object" rows="3"
              style="width: 100%;" formControlName="other"></textarea>

          </form>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<div *ngIf="modalData.isEdit" align="center" style="padding-bottom: 20px; padding-top: 20px;">
  <button mat-button class="m-3" style="background: #3E8C1A; color: #fff;" (click)="confirm()"
    [disabled]="!filterForm.valid">
    {{ modalData.actionBtnText }}
  </button>
  <button mat-button class="m-3" style="background: #c0c0c0; color: #fff;" (click)="closeModal()">
    {{ modalData.cancleBtnText }}
  </button>
</div>
